module.exports = __webpack_public_path__ + "img/p4.525e710f.png";